var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlobIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0716 14C26.0716 17.2016 24.7998 20.272 22.5359 22.5358C20.2721 24.7996 17.2017 26.0714 14.0001 26.0714C10.7986 26.0714 7.72818 24.7996 5.46435 22.5358C3.20052 20.272 1.92871 17.2016 1.92871 14M26.0716 14C26.0716 10.7985 24.7998 7.72806 22.5359 5.46423C20.2721 3.2004 17.2017 1.92859 14.0001 1.92859C10.7986 1.92859 7.72818 3.2004 5.46435 5.46423C3.20052 7.72806 1.92871 10.7985 1.92871 14M26.0716 14H1.92871",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6431 14C18.4151 18.4144 16.7891 22.6419 14.0003 26.0714C11.2114 22.6419 9.58548 18.4144 9.35742 14C9.58548 9.58561 11.2114 5.35808 14.0003 1.92859C16.7891 5.35808 18.4151 9.58561 18.6431 14Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobIcon);
export default __webpack_public_path__ + "static/media/glob-icon.6531e3281fadb692ec074f2e49911009.svg";
export { ForwardRef as ReactComponent };